export const BLOCKS = {
  A: "Toi",
  B: "Ton passé de coureur",
  C: "Tes chaussures",
  D: "Ta façon de bouger",
  E: "Ta stabilité",
  F: "Tes habitudes",
  G: "Ton objectif",
};

const yesNo = [
  { value: "oui", label: "Oui" },
  { value: "non", label: "Non" },
];

const freqOptions = [
  { value: "0", label: "Jamais", emoji: "🛋️" },
  { value: "1", label: "1 fois par semaine" },
  { value: "2", label: "2 fois par semaine" },
  { value: "3plus", label: "3 fois ou plus" },
];

export const QUESTIONS = [
  { id: "A1", block: "A", title: "Quel âge as-tu ?", type: "number", unit: "ans", min: 12, max: 99 },
  { id: "A2", block: "A", title: "Tu es…", type: "choice", options: [
    { value: "femme", label: "Une femme", emoji: "🙋‍♀️" },
    { value: "homme", label: "Un homme", emoji: "🙋‍♂️" },
    { value: "autre", label: "Autre / je préfère ne pas dire", emoji: "🙂" },
  ] },
  { id: "A3", block: "A", title: "Ta taille", type: "number", unit: "cm", min: 120, max: 230 },
  { id: "A4", block: "A", title: "Ton poids", help: "Approximatif, ça suffit.", type: "number", unit: "kg", min: 30, max: 250 },
  { id: "A5", block: "A", title: "Ton activité physique en ce moment", type: "choice", options: [
    { value: "aucune", label: "Aucune", emoji: "🛋️" },
    { value: "marche", label: "De la marche régulière", emoji: "🚶" },
    { value: "sport_1", label: "Un sport 1 fois par semaine", emoji: "🏸" },
    { value: "sport_2plus", label: "Un sport 2 fois ou plus", emoji: "💪" },
  ] },
  { id: "B1", block: "B", title: "As-tu déjà couru ?", type: "choice", options: [
    { value: "jamais", label: "Jamais", emoji: "🌱" },
    { value: "longtemps", label: "Il y a longtemps", emoji: "⏳" },
    { value: "essaye_arrete", label: "J'ai essayé récemment et arrêté", emoji: "🔁" },
    { value: "un_peu", label: "Je cours un peu", emoji: "👟" },
  ] },
  { id: "B2", block: "B", title: "Aujourd'hui, combien de temps peux-tu courir sans t'arrêter ?", type: "choice", options: [
    { value: "je_ne_sais_pas", label: "Je ne sais pas", emoji: "🤷" },
    { value: "moins_5", label: "Moins de 5 minutes" },
    { value: "5_15", label: "5 à 15 minutes" },
    { value: "15_30", label: "15 à 30 minutes" },
    { value: "plus", label: "Plus de 30 minutes" },
  ] },
  { id: "B9", block: "B", title: "Aujourd'hui, qu'est-ce que tu réussis facilement ?", help: "Le « niveau de base » pour courir sans se blesser. Coche ce qui est facile pour toi, honnêtement.", type: "multi", options: [
    { value: "accroupi", label: "Me mettre accroupi et me relever", emoji: "🧎" },
    { value: "etages", label: "Monter 3 étages sans être essoufflé", emoji: "🪜" },
    { value: "sautiller", label: "Sautiller 20 secondes sur un pied", emoji: "🦘" },
    { value: "equilibre", label: "Tenir 30 secondes en équilibre sur une jambe", emoji: "🧘" },
    { value: "aucun", label: "Aucun des quatre", emoji: "🛋️" },
  ] },
  { id: "B8", block: "B", title: "Si je te demandais de courir maintenant, quelle distance penses-tu pouvoir courir sans marcher ?", help: "Réponds honnêtement : on ne démarre jamais au-dessus de son niveau réel.", type: "choice", options: [
    { value: "moins_500", label: "Moins de 500 m" },
    { value: "500_1000", label: "500 m à 1 km" },
    { value: "1_3km", label: "1 à 3 km" },
    { value: "3_5km", label: "3 à 5 km" },
    { value: "plus_5km", label: "Plus de 5 km", emoji: "🏃" },
  ] },
  { id: "B10", block: "B", title: "Pratiques-tu (ou as-tu pratiqué récemment) un autre sport d'endurance régulier — foot, vélo, natation, fitness… — ou as-tu déjà couru régulièrement par le passé ?", help: "Ça change ton niveau de départ : un sportif qui manque de rythme de course ne démarre pas comme un vrai débutant.", type: "choice", options: yesNo },
  { id: "B11", block: "B", title: "Ta plus longue course sans marcher du dernier mois, en minutes", help: "0 si tu n'as pas couru. Un chiffre honnête vaut mieux qu'un chiffre flatteur.", type: "number", unit: "min", min: 0, max: 300 },
  { id: "B12", block: "B", title: "As-tu une blessure en cours, ou dans les 6 derniers mois ?", help: "Si oui, l'entraîneur regarde ton programme avant ta première séance.", type: "choice", options: yesNo },
  { id: "B3", block: "B", title: "As-tu déjà arrêté de courir à cause d'une douleur ?", type: "choice", options: yesNo },
  { id: "B4", block: "B", title: "Où avais-tu mal ?", help: "Tu peux choisir plusieurs zones.", type: "multi", cols: 2, showIf: (a) => a.B3 === "oui", options: [
    { value: "pied", label: "Pied" },
    { value: "cheville", label: "Cheville" },
    { value: "achille", label: "Tendon d'Achille" },
    { value: "mollets", label: "Mollets" },
    { value: "tibia", label: "Tibia" },
    { value: "ischios", label: "Ischios" },
    { value: "genou", label: "Genou" },
    { value: "adducteurs", label: "Adducteurs" },
    { value: "hanche", label: "Hanche" },
    { value: "cervicales", label: "Cervicales" },
    { value: "bas_du_dos", label: "Bas du dos" },
    { value: "autre", label: "Autre" },
  ] },
  { id: "B5", block: "B", title: "Aujourd'hui, combien de fois par semaine cours-tu ?", help: "Ce que tu fais vraiment, pas ce que tu voudrais faire.", type: "choice", options: freqOptions },
  { id: "B6", block: "B", title: "Et du renforcement (squats, fentes, gainage, escaliers…) ?", help: "Séances où tu travailles ta force, même 10 minutes.", type: "choice", options: freqOptions },
  { id: "B7", block: "B", title: "D'autres sports dans la semaine ?", help: "Vélo, natation, marche rapide, sports collectifs, yoga…", type: "choice", options: freqOptions },
  { id: "C1", block: "C", title: "Tes chaussures de course", help: "Marque et modèle. Si tu ne sais pas, ce n'est pas grave.", type: "shoe" },
  { id: "C2", block: "C", title: "Depuis combien de temps les as-tu ?", type: "choice", showIf: (a) => !!a.C1_id, options: [
    { value: "neuves", label: "Elles sont neuves", emoji: "✨" },
    { value: "moins_6m", label: "Moins de 6 mois" },
    { value: "6m_2a", label: "6 mois à 2 ans" },
    { value: "plus_2a", label: "Plus de 2 ans" },
  ] },
  { id: "C3", block: "C", title: "Sous le pied, elles te semblent…", type: "choice", showIf: (a) => !!a.C1_id, options: [
    { value: "tres_moelleuses", label: "Très moelleuses", emoji: "☁️" },
    { value: "normales", label: "Normales" },
    { value: "fermes", label: "Fermes", emoji: "🪨" },
  ] },
  { id: "C4", block: "C", title: "Tes chaussures de tous les jours sont plutôt…", type: "choice", options: [
    { value: "baskets_epaisses", label: "Des baskets épaisses", emoji: "👟" },
    { value: "plates", label: "Des chaussures plates", emoji: "🥿" },
    { value: "talons", label: "Des talons", emoji: "👠" },
    { value: "variees", label: "Très variées", emoji: "🎲" },
  ] },
  { id: "C6", block: "C", title: "Portes-tu des semelles orthopédiques ?", help: "Dans tes chaussures de course ou de ville.", type: "choice", options: yesNo },
  { id: "D1", block: "D", title: "Quand tu marches vite, qu'est-ce qui tourne un peu plus ?", type: "choice", options: [
    { value: "epaules", label: "Mes épaules", emoji: "🤸" },
    { value: "hanches", label: "Mes hanches", emoji: "💃" },
    { value: "je_ne_sais_pas", label: "Je ne sais pas", emoji: "🤷" },
  ] },
  { id: "D2", block: "D", title: "Quand tu sautes sur place, tu retombes plutôt…", type: "choice", options: [
    { value: "rebondissant", label: "Léger et rebondissant", emoji: "🦘" },
    { value: "lourd", label: "Lourd et bien ancré", emoji: "🐘" },
  ] },
  { id: "D3", block: "D", title: "Debout, tu te tiens plutôt…", type: "choice", options: [
    { value: "avant", label: "Dos bien droit et très souvent sur l'avant des pieds" },
    { value: "talons", label: "Dos un peu arrondi et plus souvent ancré sur les talons" },
    { value: "droit_talons", label: "Dos bien droit mais plus ancré sur les talons" },
    { value: "courbe_avant", label: "Dos courbé mais plutôt sur l'avant des pieds" },
  ] },
  { id: "D4", block: "D", title: "Après une longue journée assis, tu sens plutôt…", type: "choice", options: [
    { value: "hanches", label: "Mes hanches raides", emoji: "🪑" },
    { value: "bas_du_dos", label: "Le bas du dos", emoji: "🔙" },
    { value: "haut_du_dos", label: "Le haut du dos, les épaules (dos rond)" },
    { value: "chevilles", label: "Mes chevilles, mes mollets" },
  ] },
  { id: "D6", block: "D", title: "Quand tu te relèves d'un tabouret ou d'une chaise basse, sans les mains, tes pieds…", help: "Fais-le vraiment, une ou deux fois, et regarde tes pieds.", type: "choice", options: [
    { value: "talons", label: "Restent ancrés sur les talons, les orteils se soulèvent un peu" },
    { value: "plat", label: "Restent à plat, tout le pied au sol" },
    { value: "pointes", label: "Les talons se soulèvent, je pousse sur l'avant du pied" },
  ] },
  { id: "D5", block: "D", title: "Quand tu marches, tes pieds sont plutôt…", type: "choice", options: [
    { value: "droits", label: "Droits", emoji: "⬆️" },
    { value: "exterieur", label: "Tournés vers l'extérieur", emoji: "↗️" },
  ] },
  { id: "E1", block: "E", title: "Tiens sur un pied, yeux fermés. Combien de secondes ?", help: "Lance le chrono, ferme les yeux, arrête quand tu poses l'autre pied.", type: "choice", options: [
    { value: "moins_5", label: "Moins de 5 s" },
    { value: "5_15", label: "5 à 15 s" },
    { value: "15_30", label: "15 à 30 s" },
    { value: "plus_30", label: "Plus de 30 s" },
  ] },
  { id: "E2", block: "E", title: "Sur une jambe, monte 10 fois sur la pointe du pied.", help: "Tiens-toi à un meuble si besoin.", type: "choice", options: [
    { value: "facile", label: "Facile", emoji: "😎" },
    { value: "difficile", label: "Difficile", emoji: "😅" },
    { value: "impossible", label: "Impossible", emoji: "🙈" },
  ] },
  { id: "E3", block: "E", title: "Squat sur une jambe, en te tenant à un meuble : ton genou rentre-t-il vers l'intérieur ?", type: "choice", options: [
    { value: "non", label: "Non, il reste dans l'axe" },
    { value: "un_peu", label: "Un peu" },
    { value: "beaucoup", label: "Beaucoup" },
  ] },
  { id: "F1", block: "F", title: "Tu cours (ou tu courras) plutôt…", type: "choice", options: [
    { value: "dehors", label: "Dehors", emoji: "🌳" },
    { value: "tapis", label: "Sur tapis", emoji: "🏠" },
    { value: "les_deux", label: "Les deux" },
  ] },
  { id: "F2", block: "F", title: "Avec de la musique dans les oreilles ?", type: "choice", options: yesNo },
  { id: "F3", block: "F", title: "Avec une montre connectée ?", type: "choice", options: yesNo },
  { id: "G1", block: "G", title: "Ton objectif", help: "Un seul, le plus important pour toi.", type: "choice", options: [
    { value: "20min", label: "Courir 20 minutes sans m'arrêter", emoji: "⏱️" },
    { value: "5km", label: "Courir 5 km", emoji: "🎯" },
    { value: "10km", label: "Courir 10 km", emoji: "🏁" },
    { value: "reprise", label: "Reprendre après une blessure", emoji: "🩹" },
    { value: "bien_etre", label: "Me sentir mieux dans mon corps", emoji: "🌤️" },
  ] },
];
